import {Component, DestroyRef, DoCheck, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NgClass} from '@angular/common';
import {PlanModelService} from '../../common/service/plan-model.service';
import {PermissionsService} from '../../common/service/permissions.service';
import {NLR_TABS as LeftComponentTabs, PATTERNS} from '../../common/constants';
import {PlanLodgementService} from '../../common/service/plan-lodgement.service';
import {NlrUppercaseDirective} from '../../common/directive/nlr-uppercase.directive';
import {NlrPatternDirective} from '../../common/directive/nlr-pattern.directive';
import {NlrEmailDirective} from '../../common/directive/nlr-email.directive';
import {NgSelectModule} from '@ng-select/ng-select';
import {Customer} from '../../common/models/customer.model';
import {MetaData, NgEventBus} from 'ng-event-bus';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'plan-lodgement',
    imports: [NlrFormFieldHasErrorPipe, FormsModule, NgClass, NlrUppercaseDirective, NlrPatternDirective, NlrEmailDirective, NgSelectModule],
    templateUrl: './plan-lodgement.component.html',
    styleUrl: './plan-lodgement.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class PlanLodgementComponent implements DoCheck, OnInit {
    @ViewChild('applicationForTitlesDocumentIdentifierInput')
    applicationForTitlesDocumentIdentifierInput: ElementRef;

    title = 'Plan lodgement';

    lodgePermissions = ['EDIT_LODGE', 'VIEW_LODGE'];

    informationPermissions = ['EDIT_INFORMATION', 'VIEW_INFORMATION'];

    documentPattern = PATTERNS.DOCUMENT_PATTERN;

    focusApplicationForTitlesDocumentIdentifierTimeout: number;

    customers: Customer[] = [];

    constructor(
        private destroyRef: DestroyRef,
        private eventBus: NgEventBus,
        private planModelService: PlanModelService,
        private planLodgementService: PlanLodgementService,
        private permissionsService: PermissionsService
    ) {}

    ngOnInit() {
        this.eventBus
            .on<Customer[]>('planLodgementService:customers')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((meta: MetaData) => (this.customers = [...meta.data]));
    }

    ngDoCheck() {
        // Replace matching customer in customers list with model customer so the model customer is selected after load or save
        this.planLodgementService.updateCustomersWithModelCustomer();
    }

    getModel() {
        return this.planModelService.getModel();
    }

    hasInformationPermissions() {
        return this.permissionsService.hasPermission(this.informationPermissions);
    }

    hasLodgePermissions() {
        return this.permissionsService.hasPermission(this.lodgePermissions);
    }

    isCustomerDisabled() {
        return this.customers.length === 0 || this.isDisabled(this.lodgePermissions);
    }

    isPlanLotsDisabled() {
        return this.isDisabled(this.informationPermissions);
    }

    isLodgementEmailAddressDisabled() {
        return this.isDisabled(this.lodgePermissions);
    }

    isLotSyncDisabled() {
        return this.isDisabled(this.lodgePermissions);
    }

    isApplicationForTitlesDocumentIdentifierDisabled() {
        return this.isDisabled(this.lodgePermissions);
    }

    onChangeLotSync() {
        if (this.focusApplicationForTitlesDocumentIdentifierTimeout) {
            window.clearTimeout(this.focusApplicationForTitlesDocumentIdentifierTimeout);
        }

        window.setTimeout(() => {
            if (this.getModel().lotSync && this.applicationForTitlesDocumentIdentifierInput) {
                this.applicationForTitlesDocumentIdentifierInput.nativeElement.focus();
            }
        }, 100);
    }

    getPlanLotsError() {
        return this.planLodgementService.getCalculatePlanLotsError();
    }

    customerTrackBy(customer: Customer) {
        return customer?.financialAccountNumber;
    }

    lotSyncHandler() {
        return !this.planModelService.readonly && (this.getModel().lotSync = !this.getModel().lotSync);
    }

    private isDisabled(permissions: string[]) {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(permissions);
    }
}
